<template>
<div class="hy-timeinfo" v-if="postsData.conference.cover_url">
    <div class="info-bannerbox">
      <img v-lazy="postsData.conference.cover_url" class="image" width="100%" />
    </div>
    <div class="info-cont" v-if="postsData.conference != ''">
      <van-sticky>
      <h5 class="index-title">
        图文直播
        <span class="right_status" v-if="postsData.column.play_status == 1">直播未开始</span>
        <span class="right_status" v-else-if="postsData.column.play_status == 2">直播中</span>
        <span class="right_status" v-else-if="postsData.column.play_status == 3">直播暂停</span>
        <span class="right_status" v-else="postsData.column.play_status == 4">直播结束</span>
      </h5>
  </van-sticky>
      <div class="info_list">
        <div class="info_item" v-for="(item,index) in postsData.data" v-if="postsData.data.length > 0">
            <div class="info_time">
              <span><i class="iconfont">&#xe67f;</i> {{item.publish_time,'Y年M月D日 h:m:s'|formatDates}}</span>
            </div>
          <div class="info_text" v-html="item.desc"></div>
         </div>
         <div v-else>
           直播未开始
         </div>
        <div class="getMore iconfont" v-html="moreText" v-if="postsData.column.play_status != 1" @click="getMore"></div>
      </div>
    </div>
    <!--会议未开始倒计时-->
  <van-popup class="top_popup" v-model="postsData.column.play_status == 1" :close-on-click-overlay="false">
      <div class="inbox">
        <span class="right_status">直播未开始</span>
        <van-count-down v-if="postsData.column.publish_time*1000-thisTime > 0" :time="postsData.column.publish_time*1000-thisTime" format="倒计时：DD 天 HH 时 mm 分 ss 秒" />
      </div>
    </van-popup>
    <!--底部按钮-->
    <div class="hy-fixed-userBtn">
      <span class="iconfont fixed-link" @click="openFooterNav()">&#xe60c;</span>
      <div class="hy_footer_nav" :class="footerNav? 'active':''">
        <a class="nav-link iconfont" :href="'/index/conference/template?id='+id">&#xe66a; <span class="text">当前会议首页</span></a>
        <router-link class="nav-link iconfont" to="/">
          &#xe60e;
          <span class="text">会议平台首页</span>
        </router-link>
        <router-link class="nav-link iconfont" to="/myEnroll">
          &#xe609;
          <span class="text">我的会议信息</span>
        </router-link>
      </div>
    </div>
  <template v-if="Object.keys(postsData.conference).length != 0">
    <footerFixed :id="id" :jump-page="postsData.conference.jump_page"/>
</template>

  <van-notify v-model="tipshow" type="primary">
    <van-icon name="bell" style="margin-right: 4px;" />
    <span>{{tipTetx}}</span>
  </van-notify>
  </div>
</template>
<script>
  import {
    formatDates
  } from '@/assets/js/date.js';
  import {
    getCookie,
    delCookie,
    setCookie
  } from '../../http/util'; // cookie操作
  import footerFixed from  '@/components/common/fixed_setting'
  export default {
    components: {
      footerFixed
    },
    data() {
      return {
        id: "",
        active: 0,
        lmActive: 0,
        footerNav: false,
        postsData: {
          conference:{}
        },
        thisTime: new Date().getTime(),
        getmore:true,
        moreText:'查看更多&#xe617;',
        pagesize:10,
        tipshow:false,
        thisHeight:0,
        scrollTop:0,
        tipTetx:'图文已更新',
        set_status:true,
        set_time:10000
      };
    },
    created() {
      let _this = this;
      _this.id = _this.$route.params.id;
      _this.list();
     /* this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        overlay: true,
        duration: 0
      });*/
      _this.thisHeight = document.documentElement.clientHeight;
    },
    /* 时间过滤 */
    filters: {
      formatDates
    },
    mounted(){
      window.addEventListener('scroll',this.handleScroll) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
    },
    methods: {
      handleScroll(){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
        console.log(scrollTop);
        this.scrollTop = scrollTop;
        if(this.scrollTop <= this.thisHeight && this.set_status == false){
          this.set_status = true;
          this.addList();
        }
      },
      showNotify() {
        this.tipshow = true;
        setTimeout(() => {
          this.tipshow = false;
        }, 4000);
      },
      //打开底部链接
      openFooterNav(val) {
        //   this.$toast(val);
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
      list() {
        var _this = this;
        let url = "/ac1/conference/ImageDetailingDetail";
        let params = {
          conference_id: _this.id,
          pagesize:_this.pagesize
        };
        _this.$get(url, params).then(res => {
            if(res.code == 1){
              _this.postsData = res.posts;
              var wxShareInfo = {
                title: _this.postsData.conference.name,
                info: _this.postsData.conference.detail,
                shareurl: window.location.href,
                img:_this.postsData.conference.cover_url,
              };
              var shareData = {
                data: wxShareInfo, //分享配置信息
                ifshare: true,
                that: _this
              };
              _this.$WXConfig.wxShowMenu(shareData);
              setTimeout(function(){
                _this.addList();
              },_this.set_time)
            }
        });
      },
      addList(){
        var _this = this;
         var newTimes = _this.postsData.data.length > 0 ?_this.postsData.data[0].publish_time:'';
          let url = "/ac1/conference/ImageDetailingDetail";
          let params = {
            conference_id: _this.id,
            max_time:newTimes,
            pagesize:_this.pagesize
          };
          _this.$get(url, params).then(res => {
            if(res.code == 1){
              _this.postsData.column.play_status = res.posts.column.play_status;
              if(res.posts.column.play_status != 4){
                if(res.posts.data.length > 0){
                  if(_this.scrollTop <= _this.thisHeight){
                    var boxlist = _this.postsData.data;
                    var newlist = res.posts.data;
                    _this.postsData.data = newlist.concat(boxlist);
                    _this.tipTetx = '图文消息已更新';
                    _this.showNotify();
                  }else{
                    _this.tipTetx = '顶部有新的图文消息';
                    _this.showNotify();
                    _this.set_status = false;
                  }
                }
                setTimeout(function(){
                  if(_this.set_status){
                    _this.addList();
                  }
                },_this.set_time);
              }
            }
          });
      },
      getMore(){
        var _this = this;
        if(_this.getmore == false){
          return false;
        }
        let url = "/ac1/conference/ImageDetailingDetail";
        let params = {
          conference_id: _this.id,
          min_time:_this.postsData.data[_this.postsData.data.length-1].publish_time,
          pagesize:_this.pagesize
        };
        _this.$get(url, params).then(res => {
          if(res.code == 1){
            if(res.posts.data.length > 0){
              var boxlist = _this.postsData.data;
              var newlist = res.posts.data;
              _this.postsData.data = boxlist.concat(newlist);
              if(res.posts.data.length  < _this.pagesize){
                _this.getmore = false;
                _this.moreText = '没有了';
              }
            }else{
              _this.getmore = false;
              _this.moreText = '没有了';
            }
          }
        });
      }
    }
  };
</script>
<style lang="less">
  .hy-timeinfo{
    width: 100%;
    .info-bannerbox{
      width: 100%;
      position: relative;
      .image{
        width: 100%;
        min-height: 130px;
      }
      .right_status{
        position: absolute;
        top: 30px;
        right: 30px;
        z-index: 2;
        background: #fe6333;
        padding: 4px 10px;
        border-radius: 10px;
        color: #FFF;
        display: block;
        font-size: 28px;
      }
    }
    .top_popup{
      background-color: transparent;
      width: 80%;
      .inbox{
        text-align: center;
        .right_status{
          color: #FFF;
          font-size: 38px;
          margin-bottom: 30px;
          display: block;
          font-weight: 600;
        }
        .van-count-down{
          color: #fe6333;
          font-size: 30px;
          font-weight: 600;
        }
      }
    }
    .info-cont{
      width: 100%;
      padding: 30px;
      .van-sticky--fixed{
        background: #FFF;
        padding:20px 30px;
        box-shadow: 3px 2px 15px #999;
      }
      .index-title{
        width: 100%;
        text-align: left;
        border-left: 5px solid #0098f9;
        padding-left: 10px;
        overflow: hidden;
        font-size: 32px;
        color: #333;
        font-weight: 600;
        line-height: 35px;
        .right_status{
          background: #fe6333;
          padding: 2px 10px;
          border-radius: 10px;
          color: #FFF;
          display: block;
          font-size: 24px;
          float: right;
        }
      }
      .info_list{
        width: 100%;
        margin: 30px 0px;
        box-shadow: 3px 2px 15px #ebebeb;
        border-radius: 10px;
        padding: 20px;
        .info_item{
          width: 100%;
          border-left: 2px solid #1994fb;/*no*/
          .info_time{
            width: 100%;
            span{
              background: #1994fb;
              padding: 4px 30px 4px 10px;
              color: #FFF;
              border-top-right-radius: 20px;
              border-bottom-right-radius: 20px;
              font-size: 28px;
              display: inline-block;
              i{
                font-size: 28px;
              }
            }
          }
          .info_text{
            padding:40px 20px;
            width: 100%;
            font-size: 28px;
            color: #999;
            img{
              max-width: 100%;
              margin: 10px 0px;
            }
            p{
             line-height: 1.6em;
            }
          }
        }
      }
    }
  }
</style>
